<template>
  <StatusChangeProcedureApplyInput label="休学"
                                   class="status-change-procedure-apply-suspend"
                                   v-on="$listeners"
                                   v-loading="loading"
                                   element-loading-text="数据加载中，请稍等..."
                                   :resolve-form="getApplyInfo">
    <template>
      <slot></slot>
    </template>
    <template #form>
      <el-form size="mini"
               label-width="120px"
               label-suffix="：">
        <el-form-item label="休学原因">
          <el-select v-model="form.reasonCode">
            <template v-if="applyInfo && applyInfo.reasons">
              <el-option v-for="reason in applyInfo.reasons"
                         :key="reason.code"
                         :label="reason.name"
                         :value="reason.code"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isCustomReason"
                      label="休学原因详情">
          <el-input v-model="form.reasonNote"
                    type="textarea"
                    maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="已修学期数">
          <el-input-number v-model="form.finishSemesterNum"
                           controls-position="right"
                           :min="0"
                           :max="10"
                           :precision="1"
                           :step="1"></el-input-number>
        </el-form-item>
        <el-form-item label="休学时间">
          <div class="date-range">
            <el-date-picker v-model="form.suspendStartDate"
                            type="date"
                            prefix-icon="el-icon-date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择起始日期"
                            :picker-options="{disabledDate: disabledSuspendStartDate}"></el-date-picker>
            <span class="divider">至</span>
            <el-date-picker v-model="form.suspendEndDate"
                            type="date"
                            prefix-icon="el-icon-date"
                            value-format="yyyy-MM-dd"
                            placeholder="选择结束日期"
                            :picker-options="{disabledDate: disabledSuspendEndDate}"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="复学时间">
          <div class="date-period-range">
            <div class="period">
              <el-select v-model="form.reenterPreYear">
                <template v-if="getCurrentYear">
                  <el-option v-for="i in 8"
                             :key="i"
                             :label="getCurrentYear + i - 1"
                             :value="getCurrentYear + i - 1"></el-option>
                </template>
              </el-select>
              <span class="unit">年</span>
            </div>
            <div class="period">
              <el-select v-model="form.reenterPreMonth">
                <el-option v-for="m in 12"
                           :key="m"
                           :label="m"
                           :value="m"></el-option>
              </el-select>
              <span class="unit">月</span>
            </div>
            <div class="period">
              <el-select v-model="form.reenterPrePeriod">
                <el-option label="上"
                           value="上"></el-option>
                <el-option label="中"
                           value="中"></el-option>
                <el-option label="下"
                           value="下"></el-option>
              </el-select>
              <span class="unit">旬</span>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </template>
  </StatusChangeProcedureApplyInput>
</template>

<script>
import moment from 'moment'
import StatusChangeProcedureApplyInput from '../input'
import objectUtils from '../../../../../../../../../util/objectUtils'
export default {
  name: 'StatusChangeProcedureApplySuspend',
  components: {
    StatusChangeProcedureApplyInput
  },
  props: {
    studentId: {
      type: String,
      required: true
    },
    extraParams: Object,
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      applyInfo: null,
      form: {
        reasonCode: '',
        reasonNote: '',
        finishSemesterNum: undefined,
        suspendStartDate: '',
        suspendEndDate: '',
        reenterPreYear: '',
        reenterPreMonth: '',
        reenterPrePeriod: ''
      }
    }
  },
  computed: {
    getSuspendStartDate () {
      if (this.form.suspendStartDate) {
        return moment(this.form.suspendStartDate, 'YYYY-MM-DD').toDate()
      }
    },
    getSuspendEndDate () {
      if (this.form.suspendEndDate) {
        return moment(this.form.suspendEndDate, 'YYYY-MM-DD').toDate()
      }
    },
    getCurrentYear () {
      const applyInfo = this.applyInfo
      if (applyInfo) {
        let currentYear = applyInfo.currentYear
        if (currentYear) {
          return currentYear
        } else {
          return moment().year()
        }
      }
    },
    isCustomReason () {
      const reasonCode = this.form.reasonCode
      if (reasonCode) {
        const applyInfo = this.applyInfo
        if (applyInfo) {
          const reasons = applyInfo.reasons
          if (reasons) {
            let getReason = reasons.find(reason => reason.code === this.form.reasonCode)
            if (getReason) {
              return getReason.custom
            }
          }
        }
      }
    }
  },
  methods: {
    disabledSuspendStartDate (date) {
      let getSuspendEndDate = this.getSuspendEndDate
      if (getSuspendEndDate) {
        return date.getTime() > getSuspendEndDate.getTime()
      }
      return false
    },
    disabledSuspendEndDate (date) {
      let getSuspendStartDate = this.getSuspendStartDate
      if (getSuspendStartDate) {
        return date.getTime() < getSuspendStartDate.getTime()
      }
      return false
    },
    loadApplyInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/status/change/procedure/suspend/applyInfo',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.applyInfo = response.data['applyInfo'] || {}
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    getApplyInfo () {
      return new Promise((resolve, reject) => {
        if (!this.form.reasonCode) {
          reject(new Error('请选择休学原因'))
          return
        }
        if (this.isCustomReason) {
          if (!this.form.reasonNote) {
            reject(new Error('请填写休学原因详情'))
            return
          }
        }
        if (!objectUtils.hasValue(this.form.finishSemesterNum)) {
          reject(new Error('请填写已修学期数'))
          return
        }
        if (!this.form.suspendStartDate || !this.form.suspendEndDate) {
          reject(new Error('请选择休学时间'))
          return
        }
        if (!this.form.reenterPreYear || !this.form.reenterPreMonth || !this.form.reenterPrePeriod) {
          reject(new Error('请选择复学时间'))
          return
        }
        resolve(this.resolveApply(this.form))
      })
    },
    resolveApply (form) {
      return {
        url: '/workspace/manager/status/change/procedure/suspend/submitApply',
        data: this.$qs.stringify(this.$extend({
          postId: this.studentId
        }, form, this.extraParams))
      }
    }
  },
  mounted () {
    this.loadApplyInfo()
  },
  watch: {
    visible (val) {
      if (val) {
        Object.keys(this.form).forEach(key => {
          if (typeof this.form[key] === 'string') {
            this.form[key] = val[key] || ''
          } else {
            this.form[key] = val[key]
          }
        })
      }
    }
  }
}
</script>
